import { telephonyProviders } from "@/src/constants/telephonyConstants.js";
import BaseTelephonyEventHandler from "@/src/services/telephony/base/baseTelephonyEventHandler.js";
import store from "@/src/store";

class RetellEventHandler extends BaseTelephonyEventHandler {
  constructor() {
    super(telephonyProviders.retell);
    this.device = null;
    this.eventListenersRegistered = false;
  }

  async initialize(device) {
    try {
      if (!device) {
        throw new Error("Device is required");
      }
      this.device = device;

      if (!this.device.retellWebClient) {
        throw new Error("Retell web client not initialized");
      }

      this.setupDeviceListeners();
      this.eventListenersRegistered = true;

      return { success: true };
    } catch (error) {
      console.error("Failed to initialize Retell event handler:", error);
      throw error;
    }
  }

  setupDeviceListeners() {
    try {
      const client = this.device.retellWebClient;

      if (!client) {
        throw new Error("Retell client not available");
      }

      client.on("call_started", () => {
        this.handleCallStarted();
      });

      client.on("call_ended", () => {
        this.handleCallEnded();
      });

      client.on("agent_start_talking", () => {
        this.handleAgentStartTalking();
      });

      client.on("agent_stop_talking", () => {
        this.handleAgentStopTalking();
      });

      client.on("update", (update) => {
        this.handleTranscriptUpdate(update);
      });

      client.on("error", (error) => {
        this.handleError(error);
      });
    } catch (error) {
      console.error("Failed to setup device listeners:", error);
      throw error;
    }
  }

  handleCallStarted() {
    try {
      this.emit("callStarted");
      store.dispatch("voiceAgents/setCallOngoing", true);
      store.dispatch("voiceAgents/setCallStatus", "connected");
      store.dispatch("voiceAgents/updateTranscript", []); 
    } catch (error) {
      console.error("Error handling call started:", error);
    }
  }

  handleCallEnded() {
    try {
      this.emit("callEnded");
      store.dispatch("voiceAgents/endTestCall");
    } catch (error) {
      console.error("Error handling call ended:", error);
    }
  }

  handleAgentStartTalking() {
    try {
      this.emit("agentSpeaking", true);
      store.dispatch("voiceAgents/setAgentSpeaking", true);
    } catch (error) {
      console.error("Error handling agent start talking:", error);
    }
  }

  handleAgentStopTalking() {
    try {
      this.emit("agentSpeaking", false);
      store.dispatch("voiceAgents/setAgentSpeaking", false);
    } catch (error) {
      console.error("Error handling agent stop talking:", error);
    }
  }

  handleTranscriptUpdate(update) {
    try {
      if (!update || !update.transcript) {
        return;
      }
      this.emit("transcript", update.transcript);
      
      const transcript = update.transcript;
      if (!Array.isArray(transcript) || transcript.length === 0) {
        return;
      }

      store.dispatch("voiceAgents/updateTranscript", transcript);
    } catch (error) {
      console.error("Error handling transcript update:", error);
    }
  }

  handleError(error) {
    try {
      this.emit("error", error);
      const errorMessage = error?.message || "Call error occurred";
      store.dispatch("voiceAgents/setCallError", errorMessage);
      
      if (this.device?.retellWebClient) {
        this.device.retellWebClient.stopCall();
      }
      
      store.dispatch("voiceAgents/endTestCall");
    } catch (err) {
      console.error("Error handling error event:", err);
    }
  }

}

export default new RetellEventHandler();

